var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"background-mask"}),_c('div',{staticClass:"page-body"},[_c('page-header',{key:_vm.$root.lang,on:{"lang":function($event){return _vm.$emit('lang', $event, 0)}}}),_c('div',{attrs:{"id":"main"}},[_c('router-view',{key:_vm.$route.name})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }